var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-order',{attrs:{"detail":_vm.detail,"statusEnum":_vm.statusEnum}})
}
var staticRenderFns = []

export { render, staticRenderFns }